import { render, staticRenderFns } from "./DiffCardRefundDialog.vue?vue&type=template&id=3e825612&scoped=true"
import script from "./DiffCardRefundDialog.vue?vue&type=script&lang=ts"
export * from "./DiffCardRefundDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e825612",
  null
  
)

export default component.exports